import { FeedbackApi, FeedbackApiV2FeedbackPostRequest } from "@generated/v2";
import { apiClientConfiguration } from "app/constants/apiConst";
const api = new FeedbackApi(apiClientConfiguration);

export const feedbackPost = (
  requestParameters: FeedbackApiV2FeedbackPostRequest
) => api.v2FeedbackPost(requestParameters);
